/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { RootStore } from 'src/core/stores/RootStore';
import { VersionedAppId } from 'src/luis/types/VersionedAppId';

export type AddDirtyStateParameters = VersionedAppId & {
    /**
     * The root store that used to manage state.
     */
    rootStore: RootStore;
};

/**
 * Marks the request as one that "dirties" the application
 * state, meaning that the application would require a
 * training operation as the learner is no longer up to date
 * with the latest changes.
 *
 * @param input The input needed for the decorator to operate.
 */
export const addDirtyState = (input: AddDirtyStateParameters) => async (transaction: Promise<void>): Promise<void> => {
    const { rootStore, appId, versionId } = input;

    await transaction;

    const appStore = rootStore.luisAppStoreHouse.findById(appId);

    if (!appStore) {
        return;
    }

    const appVersionStore = appStore.appVersionStoreHouse.findById(versionId);

    if (!appVersionStore) {
        return;
    }

    appVersionStore.setDirty(true);
    appVersionStore.trainingStore.setCurrentTrainingStatus({ overallStatus: 'none' });
};
